import { abbreviateNumber, AbbreviateNumberFormat } from 'common/util/number';

import { DashboardJSONType, GraphConfigType } from '../types';

import './DashboardNumber.scss';

type DashboardNumberType = {
  config: GraphConfigType;
  linkValue: string;
  numberValue?: number;
};

export const isNumberGraph = (config: GraphConfigType): boolean => (config.graphStyle !== undefined && config.graphStyle !== null && config.graphStyle === 'number');

/**
 * Displays a big number based on the results of a power query or graph function.
 *
 * @prop config       The dashboard graph config for formatting
 * @prop linkValue    Link to the power query or events page
 * @prop numberValue  The number to display
  */
function DashboardNumber({
  config,
  linkValue,
  numberValue,
}: DashboardNumberType): JSX.Element {

  if (numberValue === undefined) {
    return (
      <div className="DashboardNumber">
        <a href={linkValue} className="DashboardNumber__Link DashboardNumber__Link--NoResults">
          No results
        </a>
      </div>
    );
  }

  const text = abbreviateNumber(numberValue, config.options?.format?.length > 0 ? config.options.format.toUpperCase() : AbbreviateNumberFormat.AUTO, config.options?.precision);
  const suffix = config.options?.suffix && numberValue !== undefined ? <span className="DashboardNumber__Suffix">{config.options.suffix}</span> : <></>;

  const containerStyle: DashboardJSONType = { backgroundColor: config.options?.backgroundColor ? config.options.backgroundColor : 'inherit' };
  const linkStyle: DashboardJSONType = { color: config.options?.color ? config.options.color : 'inherit' };

  return (
    <div className="DashboardGraph__Content DashboardGraph__Content--chart">
      <div className="DashboardNumber" style={containerStyle}>
        <a style={linkStyle} href={linkValue} className="DashboardNumber__Link">
          {text}
        </a>
        <span style={linkStyle} className="DashboardNumber__Link">
          {suffix}
        </span>
      </div>
    </div>
  );
}

export default DashboardNumber;
